/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', () => {
  const comingSoonButtons = document.querySelectorAll('[data-coming-soon="true"]');

  comingSoonButtons.forEach((button) => {
    const text = button.querySelector('[data-add-to-cart-text]');

    if (!text) return;

    const keepComingSoon = () => {
      if (button.disabled) {
        text.textContent = 'COMING SOON';
      }
    };

    keepComingSoon();

    const observer = new MutationObserver(keepComingSoon);
    observer.observe(text, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });
});
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
